import { render, staticRenderFns } from "./TaskDonation.vue?vue&type=template&id=81b23df6&scoped=true&"
import script from "./TaskDonation.vue?vue&type=script&lang=js&"
export * from "./TaskDonation.vue?vue&type=script&lang=js&"
import style0 from "./TaskDonation.vue?vue&type=style&index=0&id=81b23df6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b23df6",
  null
  
)

export default component.exports